export default "__VITE_ASSET__lojFp_iv__";